(function() {
  var sliderInitialized = false;
  var flkty;
  
  function initTestimonialSlider() {
    var slider = document.getElementById('testimonial-slider');
    
    if (sliderInitialized || !slider || typeof Flickity === 'undefined') {
      if (!sliderInitialized) setTimeout(initTestimonialSlider, 100);
      return;
    }

    // First make all slides visible temporarily
    var slides = slider.querySelectorAll('.testimonial__item');
    slides.forEach(function(slide) {
      slide.style.display = 'block';
      slide.style.opacity = '1';
      slide.style.visibility = 'visible';
    });

    function positionSlides() {
      if (!flkty || typeof flkty.selectedIndex === 'undefined') return;
      
      var slides = slider.querySelectorAll('.testimonial__item');
      if (!slides.length) return;
      
      var centerIndex = flkty.selectedIndex;
      
      // Reset all slides
      slides.forEach(function(slide) {
        slide.className = 'testimonial__item';
        slide.style.cssText = '';
        slide.style.display = 'none';
        slide.style.pointerEvents = 'none';
        slide.style.transform = 'none';
        slide.style.left = '0';
        slide.style.position = 'absolute';
      });

      // Position visible slides
      for (var i = -2; i <= 2; i++) {
        var slideIndex = (centerIndex + i + slides.length) % slides.length;
        var slide = slides[slideIndex];
        if (!slide) continue;
        
        slide.style.display = 'block';
        
        if (i === 0) {
          slide.classList.add('center-slide');
          slide.style.pointerEvents = 'auto';
        } 
        else if (i === -1) {
          slide.classList.add('left-1');
        }
        else if (i === -2) {
          slide.classList.add('left-2');
        }
        else if (i === 1) {
          slide.classList.add('right-1');
        }
        else if (i === 2) {
          slide.classList.add('right-2');
        }
      }
    }

    flkty = new Flickity(slider, {
      cellAlign: 'center',
      contain: false,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      draggable: true,
      dragThreshold: 20,
      selectedAttraction: 0.03,
      friction: 0.28,
      freeScroll: false,
      percentPosition: false,
      initialIndex: 0,
      on: {
        ready: function() {
          positionSlides();
          setTimeout(function() {
            positionSlides();
            flkty.resize();
          }, 100);
        },
        change: positionSlides,
        dragStart: function() {
          slider.classList.add('is-dragging');
        },
        dragEnd: function() {
          slider.classList.remove('is-dragging');
          positionSlides();
        },
        select: positionSlides,
        settle: positionSlides,
        staticClick: function(event, pointer, cellElement, cellIndex) {
          if (cellElement) {
            this.selectCell(cellIndex);
          }
        }
      }
    });

    // Handle window resize
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (flkty) {
          positionSlides();
          flkty.resize();
        }
      }, 250);
    });

    sliderInitialized = true;
  }

  // Initialize
  if (document.readyState === 'complete') {
    initTestimonialSlider();
  } else {
    document.addEventListener('DOMContentLoaded', initTestimonialSlider);
  }

  // Fallback initialization
  var fallbackCheck = setInterval(function() {
    if (document.querySelector('#testimonial-slider .testimonial__item')) {
      initTestimonialSlider();
      clearInterval(fallbackCheck);
    }
  }, 200);
})();